/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workflowsPause } from "../../funcs/workflowsPause.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PostApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdPauseRequest$inboundSchema,
};

export const tool$workflowsPause: ToolDefinition<typeof args> = {
  name: "workflows_pause",
  description: `Pause workflow execution

Pauses the execution of a specific workflow`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workflowsPause(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
